"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.environment = void 0;
var environment = {
  production: process.env.NODE_ENV === 'production',
  partnerKey: process.env.STORYBOOK_API_KEY,
  apiDomain: process.env.STORYBOOK_API_DOMAIN || 'https://api.level.travel',
  defaultDomain: 'level.travel'
};
exports.environment = environment;